module.exports = __webpack_public_path__ + "static/media/delete.76eb508c.svg";